import { GET_SPECIAL_EVENT_ITEM_AVAILABILITY } from '../../constants';
/**
 * getSpecialEventItemAvailabilityAction - Checks overall item availability for products sold during special events
 *
 * @param {String} storeId - id for the customer's selected store
 * @param {Number} selectedDate - Customer's currently selected date in Epoch format, Exp: 1686597712
 * @param {String} selectedTime - Customer's currently selected time Exp: "0900"
 *
 */
export default function getSpecialEventItemAvailabilityAction(storeId, selectedDate, selectedTime) {
    return {
        type: GET_SPECIAL_EVENT_ITEM_AVAILABILITY,
        storeId,
        selectedDate,
        selectedTime,
    };
}
